"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const Grid_1 = __importDefault(require("./Grid"));
const Row = (props) => react_1.default.createElement(Grid_1.default, Object.assign({ columns: 12 }, props));
exports.default = withJourney_1.default('j-row', Row);
